import { deepForEach } from './childrenDeepMap';
import { isTab, isTabPanel } from './elementTypes';
export function getTabsCount(children) {
  var tabCount = 0;
  deepForEach(children, function (child) {
    if (isTab(child)) tabCount++;
  });
  return tabCount;
}
export function getPanelsCount(children) {
  var panelCount = 0;
  deepForEach(children, function (child) {
    if (isTabPanel(child)) panelCount++;
  });
  return panelCount;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-tabs/esm/helpers/count.js
// module id = null
// module chunks = 